'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonProps = undefined;
exports.ButtonIcon = ButtonIcon;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _button = require('@marmalade/button');
var _button2 = _interopRequireDefault(_button);
var _icon = require('@marmalade/icon');
var _icon2 = _interopRequireDefault(_icon);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
ButtonIcon.propTypes = {
  position: (0, _propTypes.oneOf)(['prev', 'next']).isRequired
};
function ButtonIcon(_ref) {
  var position = _ref.position;
  return _react2.default.createElement(_icon2.default, {
    type: position === 'prev' ? 'arrow-left' : 'arrow-right',
    css: {
      marginRight: position === 'prev' ? '.5rem' : 0,
      marginLeft: position === 'prev' ? 0 : '.5rem'
    }
  });
}
var buttonProps = exports.buttonProps = {
  text: _propTypes.string.isRequired,
  link: _propTypes.string,
  submit: _propTypes.bool,
  prominence: (0, _propTypes.oneOf)(['primary', 'default', 'secondary']),
  onClick: _propTypes.func,
  icon: _propTypes.bool,
  disabled: _propTypes.bool,
  posting: _propTypes.bool,
  size: (0, _propTypes.oneOf)(['default', 'lg', 'sm', 'xl'])
};
FormNavButton.propTypes = Object.assign({}, buttonProps, {
  position: (0, _propTypes.oneOf)(['prev', 'next']),
  block: _propTypes.bool
});
FormNavButton.defaultProps = {
  link: undefined,
  submit: false,
  prominence: undefined,
  onClick: undefined,
  icon: true,
  disabled: false,
  posting: false,
  block: false,
  size: 'lg'
};
function FormNavButton(props) {
  var content = _react2.default.createElement(_react.Fragment, null, props.position === 'next' && props.text, props.icon !== false && _react2.default.createElement(ButtonIcon, {
    position: props.position
  }), props.position === 'prev' && props.text);
  var sharedProps = {
    size: props.size,
    block: props.block,
    disabled: props.disabled,
    posting: props.posting,
    id: props.id
  };
  if (typeof props.link !== 'undefined') {
    return _react2.default.createElement(_button.LinkButton, Object.assign({
      to: props.link,
      prominence: props.prominence || 'default'
    }, sharedProps), content);
  }
  return _react2.default.createElement(_button2.default, Object.assign({
    submit: true,
    onClick: props.onClick,
    prominence: props.prominence || 'primary'
  }, sharedProps), content);
}
exports.default = FormNavButton;